module.exports = __webpack_public_path__ + "static/img/zhidao.93ba20f5.png";